/**
 * Access reviews live under People › Access reviews. This route stays so
 * existing deep links (Tests, Inbox, Vera, breadcrumbs) keep working.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/reviews/access'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      href: `/workspaces/${params.workspaceId}/people?tab=access-reviews`,
    })
  },
})
